<div class="c-sidebar--hello">
  <div class="c-sidebar--hello__top">
    <div class="c-sidebar--hello__top__left">
      <div class="c-sidebar--hello__top__left__icon-wrapper">
        <img [src]="data?.user_logo || logoPath" [alt]="data?.first_name" class="hello-logo-js" />
      </div>
    </div>
    <div class="c-sidebar--hello__top__center">
      <div class="c-sidebar--hello__top__center__top">
        <gtd-ui-field-default-string-whitespace-or-empty
          [data]="isLoading ? 'loading...' : data?.first_name"
          [customClass]="'affiliate-name'"
        >
        </gtd-ui-field-default-string-whitespace-or-empty>
        <gtd-ui-field-default-string-whitespace-or-empty [data]="isLoading ? ' ' : data?.last_name" [customClass]="'affiliate-name'">
        </gtd-ui-field-default-string-whitespace-or-empty>
      </div>
    </div>
    <div *ngIf="subAffiliates.length" class="c-sidebar--hello__top__right">
      <div class="c-sidebar--hello__top__right__icon" (click)="toggleSubAffiliates()">
        <p500-ui-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'" size="12px"></p500-ui-icon>
      </div>
    </div>
  </div>
  <div *ngIf="subAffiliates.length" [hidden]="!isOpen" class="c-sidebar--hello__middle">
    <gtd-switch-account-widget [affiliates]="subAffiliates"></gtd-switch-account-widget>
  </div>
  <div *ngIf="masterAffiliateToken" class="c-sidebar--hello__return">
    <button p500-ui-confluent-button color="primary" i18n="@@common.return_to_master_aff" (click)="returnToMaster()">
      Return to Master Affiliate
    </button>
  </div>
  <div class="separator"></div>
  <div class="c-sidebar--hello__bottom">
    <gtd-ui-current-time></gtd-ui-current-time>
  </div>
</div>
